import React from 'react'

import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import SlideUpAnimation from '../../components/common/SlideUpAnimation'
import { lgText, xxlText } from '../../style/text'

const Gallery = ({ data }: any) => {

  const { name, files } = data

  return (
    <div className={`flex flex-col bg-emerald-50`}>
      <div className='flex flex-col py-[40px] px-[25px] lg:px-[100px] 2xl:px-[300px] max-w-[2500px] w-full m-auto'>
        <div className='flex flex-col justify-center items-center bg-[#10b981] py-6 px-5 text-center'>
          <h1 className={`${xxlText}`}>{name}</h1>
        </div>
      </div>
      <div className='bg-[#064e3b] m-auto grid grid-cols-1 xl:grid-cols-2 gap-4 p-3 xs:p-5 max-w-[1780px] w-full'>
        {files.map(({ url }: any, i: number) => (
          <SlideUpAnimation
            key={`${i}-${url}`}
            className='flex flex-col gap-3 bg-[#f7f7f8] rounded p-5 xs:p-8'
          >
            <h1 className={`${lgText} text-[#00f]`}>
              {(i + 1).toString().padStart(2, '0')}
            </h1>
            <div className='h-[520px] 2xl:h-[620px] overflow-hidden flex items-center 2xl:items-start justify-center'>
              <LazyLoadImage
                effect='blur'
                src={url}
                alt=''
                className=' min-w-[500px]  w-full h-auto'
              />
            </div>
          </SlideUpAnimation>
        ))}
      </div>
    </div>
  )
}

export default Gallery
